// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }



// 获取 地址卡片
export function addressCardList(params) {
  return request({
    url: "/api/common/address_card",
    method: "get",
    params,
  });
}


// 获取 区代理发售上联系电话
export function districtAgentTelList(params) {
  return request({
    url: "/api/common/district_agent_tel",
    method: "get",
    params,
  });
}


